import { render } from "./PreSignInCarousel.vue?vue&type=template&id=47c962b6"
import script from "./PreSignInCarousel.vue?vue&type=script&lang=js"
export * from "./PreSignInCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__